import { useResponsive } from 'commons/components/Responsive';

export function useIsSavedSearchesEnabled() {
  const { isMobile } = useResponsive();

  return !isMobile;
}
